import React, { Component } from 'react';
import ReactTable from 'react-table';
import { currency_symbol } from '../../../../server/constants';
import { convertTwoDecimalPoint } from '../../../../server/util';

class StudentPurchaseReport extends Component {

    render() {
        const { purchaseData, mealSchoolId } = this.props;
        const checkboxProps = {
            getTheadProps: () => {
                return {
                    style: {
                        backgroundColor: "#D2D7D4", fontWeight: 'bold'
                        // color: selected ? 'white' : 'inherit',
                    },
                    className: "bg-success base-reverse"
                };
            },
            getTableProps: () => {
                return {
                    className: "table table-hover"
                }
            },
        };
        return (
            <div>
                <ReactTable
                    columns={[
                        {
                            Header: "Date",
                            accessor: "transactionDate",
                            style: { textAlign: 'center' },
                            width: 150
                        },
                        {
                            Header: "Time",
                            accessor: "transactionTime",
                            style: { textAlign: 'center' },
                            width: 150
                        },
                        {
                            Header: `Amount (${currency_symbol(mealSchoolId)})`,
                            id: 'amount',
                            width: 150,
                            accessor: row => {
                                return (
                                    <div style={{ textAlign: "right" }}>
                                        {
                                            currency_symbol(mealSchoolId) + ' ' + convertTwoDecimalPoint(row.amount)
                                        }
                                    </div>
                                );
                            }
                        },
                        {
                            Header: "Type",
                            accessor: "itemPurchased",
                            style: { textAlign: 'center' },
                            width: 100
                        },
                        {
                            Header: "Category",
                            accessor: "category",
                            style: { textAlign: 'center' },
                            width: 100
                        },
                        {
                            Header: "Item",
                            id: 'items',
                            accessor: row => {
                                const { items } = row;
                                return <ul>{
                                    items.map((item) => {
                                        return <li key={item.id}><div>{`${item.itemName} - ${item.qty}`}</div></li>
                                    })}

                                </ul>

                            }
                        }, {
                            Header: "Location",
                            accessor: "location",
                            width: 100
                        },
                    ]} data={purchaseData} defaultPageSize={10} {...checkboxProps} />

            </div>
        );
    }
}

export default StudentPurchaseReport;


// WEBPACK FOOTER //
// ./src/components/Parent/Home/StudentAccount/StudentPurchaseReport.js